import {BaseContainerModel} from '../base-container.model';
import {app_login_mfa_registration_RowClass} from '../../dbschema/app_login_mfa_registration.model';

export class AppLoginMFARegistrationContainerModel extends BaseContainerModel {
    app_login_mfa_registration: app_login_mfa_registration_RowClass = new app_login_mfa_registration_RowClass();
}
